import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";


import { useSmoothScroll } from "./hooks/useSmoothScroll";

import { InvitationProvider } from "./components/InvitationContext";
import { CustomCursor } from "./components/CustomCursor";

function AppContent() {
  useSmoothScroll();
  return <AppRoutes />;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <CustomCursor />
        <InvitationProvider>
          <AppContent />
        </InvitationProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
